// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import type {ProfileUpdateStartAction, ProfileUpdateSuccessAction, ProfileUpdateThunkAction} from "../profileUpdateAction";
import type {Profile} from "../../../components/profile/ProfilePage";
import {setProfile} from "../../../dao/localStorageProfileDao";

function profileUpdateStartAction(profile: Profile): ProfileUpdateStartAction {
    return {
        type: "profile/UPDATE_START_ACTION",
        profile: Object.assign(profile)
    };
}

function profileUpdateSuccessAction(profile: Profile): ProfileUpdateSuccessAction {
    return {
        type: "profile/UPDATE_SUCCESS_ACTION",
        profile: Object.assign(profile)
    }
}

export function profileUpdateAction(profile: Profile): ProfileUpdateThunkAction {

    return async (dispatch) => {

        dispatch(profileUpdateStartAction(profile));
        setProfile(profile);
        dispatch(profileUpdateSuccessAction(profile));
    }
}


// WEBPACK FOOTER //
// ./src/actions/profile/creators/profileUpdateActionCreator.js